import ReminiscencePlatform from './ReminiscencePlatform';

function App() {
  return <ReminiscencePlatform />;
}

export default App;